<script lang="ts" setup>
import { useBrandExposure } from '@/composables/tracks/useBrandExposure'
import { superstoryTrack } from '@/track'

interface Props {
  columnId?: string
  // 标题文本
  titleText?: string
  // 操作按钮文本
  actionTextValue?: string
  // 样式配置
  cardClass?: string
  headerClass?: string
  // 标题 / 操作文案样式（可选，默认值 = 改造前写死的类名）
  titleClass?: string
  actionClass?: string
  // 是否显示标题
  showTitle?: boolean
  // 是否显示操作按钮
  showAction?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  titleText: '',
  actionTextValue: 'See All',
  cardClass: 'mt-3.75 px-3.75 py-5 bg-n-bg-card rounded overflow-hidden',
  headerClass: '-mb-5px flex items-baseline justify-between',
  titleClass: 'text-17px font-bold text-n-text-1',
  actionClass: 'text-13px flex items-center text-n-text-3 cursor-pointer',
  showTitle: true,
  showAction: true,
})

const emit = defineEmits<{
  (event: 'action'): void
}>()

const columnRef = useBrandExposure('column_exp', () => ({ column_id: props.columnId, column_name: props.titleText }))
const moreRef = useBrandExposure('see_all_button_exp', () => ({ column_id: props.columnId, column_name: props.titleText }))
// 处理操作点击
function handleAction() {
  superstoryTrack('see_all_button_ck', { column_id: props.columnId, column_name: props.titleText })
  emit('action')
}
</script>

<template>
  <div :class="cardClass">
    <!-- 头部：标题和操作 -->
    <div v-if="showTitle || showAction" :class="headerClass">
      <!-- 左侧标题 -->
      <p v-if="showTitle" ref="columnRef" :class="titleClass">
        {{ titleText }}
      </p>
      <div v-else />

      <!-- 右侧操作 -->
      <div v-if="showAction">
        <p ref="moreRef" :class="actionClass" @click="handleAction">
          <span>{{ actionTextValue }}</span>
          <i-icon-park-outline-right />
        </p>
      </div>
    </div>

    <!-- 内容插槽 -->
    <slot />
  </div>
</template>

<style scoped>
.cursor-pointer {
  cursor: pointer;
}
</style>
